import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Analytics } from "@vercel/analytics/react";
import { ThemeProvider } from "@bastion/config";
import { QueryProvider } from "./providers/QueryProvider";
import { App } from "./App";
import "../styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <QueryProvider>
          <App />
          <Analytics />
        </QueryProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);

// force rebuild
